export default "/images/4475df8cffdb41015706a142d7110ac4.avif";